import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Slides from '@ifeng/ui_pc_slides';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import { isIE78 } from '../../../../utils/utils';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    sliderTmpl = item => {
        return (
            <div className={styles.big_pic}>
                <a href={item.url} className={styles.pic_img} target="_blank" data-nomask>
                    <img src={item.thumbnail} className={styles.trans} />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} target="_blank" data-innermask>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    render() {
        const {
            content: {
                newsSlide0,
                newsSlide1,
                newsSlide2,
                newsSlide3,
                newsSlide4,
                newsSlide5,
                newsSlide6,
                newsSlide7,
                newsSlide8,
                hotTitle,
                hotNews,
                shopInHotNews,
            },
        } = this.props;

        const newsSlide = [
            ...newsSlide0,
            ...newsSlide1,
            ...newsSlide2,
            ...newsSlide3,
            ...newsSlide4,
            ...newsSlide5,
            ...newsSlide6,
            ...newsSlide7,
            ...newsSlide8,
        ];

        const config = {
            dots: false,
            arrows: 'hover',
            autoplayInterval: 5000,
            direction: 'forward',
            axis: 'horizonta',
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={styles.left_box}>
                <div className={isIE78() ? styles.slide : styles.slide_2x}>
                    <Slides content={newsSlide} config={config} />
                </div>
                <div className={styles.hot_box}>
                    <Chip id="170169" type="struct" title="热点标题" groupName="热点区" content={hotTitle}>
                        <NewsTitle size="middle" />
                    </Chip>
                    <Chip
                        id="195849"
                        type="recommend"
                        title="热点列表"
                        groupName="热点区"
                        content={hotNews}
                        translate="handleNewsData">
                        <NewsList hasTitle isBig size="long" />
                    </Chip>
                    <Chip
                        id="195850"
                        type="recommend"
                        title="热点区电商"
                        groupName="热点区"
                        content={shopInHotNews}
                        translate="handleNewsData">
                        <NewsList size="long" />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
